import {
  AlpineCartBridgeStatus,
  ReportedAlpineCartBridgeStatus
} from './alpine-cart-bridge-types';

export const ALPINE_CART_BRIDGE_LOAD_GRACE_MS = 8000;
export const ALPINE_CART_BRIDGE_MOUNT_TIMEOUT_MS = 45000;
export const ALPINE_CART_RESPONSE_TIMEOUT_MS = 30000;
export const ALPINE_CART_START_SHOPPING_TIMEOUT_MS = 10000;

export const ALPINE_CART_RESPONSE_TIMEOUT_MESSAGE =
  'The Alpine storefront did not respond. Please try again.';

const BRIDGE_STATUS_MESSAGES: Record<AlpineCartBridgeStatus, string> = {
  loading:
    'The Alpine storefront is still loading. Wait a moment and try again.',
  ready: '',
  unauthenticated:
    'The Alpine storefront does not recognize your PartnerNet login. Log in to PartnerNet again and retry.',
  unavailable:
    'Could not connect to the Alpine storefront. Refresh the page and try again.'
};

const REPORTED_STATUSES: readonly ReportedAlpineCartBridgeStatus[] = [
  'ready',
  'unauthenticated'
];

export const getAlpineClientUrl = (): string =>
  process.env.REACT_APP_ALPINE_CLIENT_URL || '';

export const isFromAlpineClient = (
  origin: string,
  alpineClientUrl: string
): boolean => {
  if (!alpineClientUrl) return false;
  try {
    return origin === new URL(alpineClientUrl).origin;
  } catch {
    return false;
  }
};

export const readReportedBridgeStatus = (
  data: unknown
): ReportedAlpineCartBridgeStatus | null => {
  if (typeof data !== 'object' || data === null) return null;
  const { alpineClientBridge } = data as {
    alpineClientBridge?: { status?: unknown };
  };
  const status = alpineClientBridge?.status;
  return REPORTED_STATUSES.find((candidate) => candidate === status) ?? null;
};

export const readCallbackEvent = (data: unknown): string | null => {
  if (typeof data !== 'object' || data === null) return null;
  const { callbackEvent } = data as { callbackEvent?: unknown };
  return typeof callbackEvent === 'string' ? callbackEvent : null;
};

export const bridgeUnavailableMessage = (
  status: AlpineCartBridgeStatus
): string => BRIDGE_STATUS_MESSAGES[status];
